var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '../utils/styled-components';
import tableTheme from './theme';
import { ComponentThemeProvider } from '../ThemeProvider';
export var TableAtom = styled.table(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-collapse: collapse;\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  border-collapse: collapse;\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var isGrid = _a.isGrid, component = _a.theme.component;
    return isGrid &&
        "\n  & td,\n  & th {\n    border-right: " + component.table.td.border + ";\n  }\n\n  & th {\n    background: " + component.table.th.background + ";\n  }\n\n  & td,\n  & tbody th {\n    border-bottom: " + component.table.td.border + ";\n  }\n\n  & tbody th {\n    border-right: " + component.table.th.border + ";\n  }\n\n  & td:last-child,\n  & th:last-child {\n    border-right: none;\n  }\n\n  & tbody tr:last-child {\n    td,\n    th {\n      border-bottom: none;\n    }\n  }\n  ";
}, function (_a) {
    var isGrid = _a.isGrid, hasRowCaptions = _a.hasRowCaptions, component = _a.theme.component;
    return (isGrid || hasRowCaptions) &&
        "\n  & thead th:first-child {\n    border-right: " + component.table.th.border + ";\n  }\n  ";
}, function (_a) {
    var isGrid = _a.isGrid, highlightHover = _a.highlightHover, component = _a.theme.component;
    return (isGrid || highlightHover) &&
        "\n  & td:hover {\n    background: " + component.table.td.backgroundHover + ";\n  }\n  ";
});
export var TdAtom = styled.td(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", ";\n  color: ", ";\n  font-size: ", ";\n  background: ", ";\n"], ["\n  padding: ", ";\n  color: ", ";\n  font-size: ", ";\n  background: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.table.td.padding;
}, function (_a) {
    var component = _a.theme.component;
    return component.table.td.color;
}, function (_a) {
    var component = _a.theme.component;
    return component.table.td.fontSize;
}, function (_a) {
    var component = _a.theme.component;
    return component.table.td.background;
});
var StyledTdColored = styled(TdAtom)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.table.td.backgroundHighlight;
});
var StyledTh = styled(TdAtom)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  background: ", ";\n  border-bottom: ", ";\n"], ["\n  color: ", ";\n  background: ", ";\n  border-bottom: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.table.th.color;
}, function (_a) {
    var component = _a.theme.component;
    return component.table.th.background;
}, function (_a) {
    var component = _a.theme.component;
    return component.table.th.border;
});
export var ThAtom = function (props) { return React.createElement(StyledTh, __assign({}, props, { as: "th" })); };
var StyledThColored = styled(ThAtom)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.table.th.backgroundHighlight;
});
var StyledEmptyTh = styled(ThAtom)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border-right: ", ";\n"], ["\n  border-right: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.table.th.border;
});
var StyledTbodyTh = styled(StyledEmptyTh)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  border-bottom: none;\n"], ["\n  border-bottom: none;\n"])));
var renderHeadings = function (headings, _a) {
    var hasRowCaptions = _a.hasRowCaptions, isStriped = _a.isStriped;
    return (React.createElement("thead", null,
        React.createElement("tr", null,
            hasRowCaptions && React.createElement(StyledEmptyTh, null),
            headings.map(function (heading) {
                if (isStriped) {
                    return React.createElement(StyledThColored, { key: heading.key }, heading.content);
                }
                return React.createElement(ThAtom, { key: heading.key }, heading.content);
            }))));
};
var renderBody = function (rows, colDefinition, _a) {
    var hasRowCaptions = _a.hasRowCaptions, isStriped = _a.isStriped;
    return (React.createElement("tbody", null, rows.map(function (_a, rowIndex) {
        var cols = _a.cols, caption = _a.caption;
        return (React.createElement("tr", { key: rowIndex },
            hasRowCaptions && React.createElement(StyledTbodyTh, { key: rowIndex + "-caption" }, caption),
            colDefinition.map(function (colDef) {
                if (isStriped && rowIndex % 2) {
                    return React.createElement(StyledTdColored, { key: colDef.key }, cols[colDef.key]);
                }
                return React.createElement(TdAtom, { key: colDef.key }, cols[colDef.key]);
            })));
    })));
};
export var Table = function (_a) {
    var headings = _a.headings, rows = _a.rows, isGrid = _a.grid, isStriped = _a.striped, highlightHover = _a.highlightHover, className = _a.className;
    var options = {
        hasRowCaptions: isGrid && rows && rows[0] && Boolean(rows[0].caption),
        isStriped: !isGrid && isStriped,
        isGrid: isGrid,
        highlightHover: highlightHover,
    };
    return (React.createElement(ComponentThemeProvider, { theme: tableTheme },
        React.createElement(TableAtom, __assign({}, options, { className: className }),
            renderHeadings(headings, options),
            renderBody(rows, headings, options))));
};
export default Table;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=index.js.map